import Api from "../common/Api";
import {Form, Input, message, Modal} from "antd";
import React, {useState} from "react";

interface Refresh {
    [key: number]: number;
}


interface Props {
    username?: string;
    isVisible: {
        user: boolean,
        group: boolean
    };
    setVisible: React.Dispatch<React.SetStateAction<{
        user: boolean,
        group: boolean
    }>>;
    refresh: Refresh;
    setRefresh: React.Dispatch<React.SetStateAction<Refresh>>
}

const NewGroupModal = (props: Props) => {
    const [form] = Form.useForm();
    const [inputValue, setInputValue] = useState<string>("")
    const [buttonLoading, setButtonLoading] = useState(false);

    return (
        <Modal
            title={`Create a new group`}
            visible={props.isVisible.group}
            okText={'Create group'}
            cancelText={'Cancel'}
            confirmLoading={buttonLoading}
            okButtonProps={{
                disabled: !inputValue.length || inputValue.includes(' ')
            }}
            onOk={async () => {
                try {
                    setButtonLoading(true);
                    const values = await form.validateFields();
                    await Api.groupsManagement.createGroup(values.group);
                    setInputValue("")
                    props.setVisible({...props.isVisible, group: false});
                    form.resetFields();
                    props.setRefresh({...props.refresh, 3: props.refresh["3"] + 1})
                    message.success("Group created!");
                } catch (e) {
                    message.error("Can't create group");
                } finally {
                    setButtonLoading(false)
                }
            }}
            onCancel={() => props.setVisible({...props.isVisible, group: !props.isVisible.group})}
        >
            <Form
                form={form}
                style={{height: "100%"}}
                name="basic"
                labelAlign={"left"}
                wrapperCol={{span: 24}}
                autoComplete="off"
            >

                <Form.Item
                    name="group"
                    hasFeedback
                    rules={[{required: true, message: "Please enter a group name!"},
                    {validator: (_, value) =>
                        !value.includes(" ")
                        ? Promise.resolve()
                        : Promise.reject(new Error("No spaces allowed"))}]}
                >
                    <Input value={inputValue} onChange={(val) => setInputValue(val.currentTarget.value)} placeholder="Group name"/>
                </Form.Item>
            </Form>
        </Modal>

    )
}

export default NewGroupModal;
